module.exports = __webpack_public_path__ + "img/logo-branco-cna.b3bbc23d.svg";